import { EventsCountByTag } from "./EventsCountByTag";
import { Sports } from "./Sports";
import { SportsGroupedByDate } from "./SportsGroupedByDate";
export const createConnections = (meta) => {
    return {
        filterEventsCountByTag() {
            return new EventsCountByTag(meta);
        },
        filterSports() {
            return new Sports(meta);
        },
        filterSportsGroupedByDate() {
            return new SportsGroupedByDate(meta);
        }
        // filterPersonalizedSports(): IFilterConnection {
        //     return new PersonalizedSports(meta)
        // }
    };
};
//# sourceMappingURL=index.js.map